import { useState, useEffect } from 'react'
import { CardSection } from 'shared/components/CardSection'
import Button from 'shared/components/Button'
import { setSearchMode } from 'map/actions'
import { SEARCH_MODE_MONTHLY } from 'search/constants'
import styles from 'purchase-flow/styles.module.scss'

import { ProductWithRates } from './ProductWithRates'

const ProductSelection = ({ products, pending, onNext, value, noQuantity, setSearchMode }) => {
    const [selectedRate, setSelectedRate] = useState(value || null)

    const error = pending && pending instanceof Error && pending.message

    useEffect(() => {
        setSearchMode(SEARCH_MODE_MONTHLY)
    }, [])

    const selectRate = (rate, prd) => {
        if (selectedRate?.ratePlanId !== rate.ratePlanId) {
            const quantity = selectedRate?.prdctCd === prd.prdctCd ? selectedRate?.quantity : 1
            setSelectedRate({
                rateId: rate.ratePlanId,
                quantity,
                prdctCd: prd.prdctCd,
                rate,
            })
        }
    }
    const changeQuantity = (productCode, quantity) => {
        if (selectedRate?.prdctCd === productCode && quantity >= 1 && quantity <= 20) {
            setSelectedRate(prevState => ({ ...prevState, quantity }))
        }
    }

    const onNextClick = () => {
        const product = products.find(prd => prd.prdctCd === selectedRate.prdctCd)
        onNext({ ...selectedRate, displayValue: product.prdctName })
    }

    return (
        <CardSection className={styles.contentSection} loading={pending && !error}>
            {products &&
                products.map((prd, i) => (
                    <ProductWithRates
                        key={i}
                        changeQuantity={!noQuantity && selectedRate?.prdctCd === prd.prdctCd && changeQuantity}
                        selectedRate={selectedRate}
                        selectRate={rate => selectRate(rate, prd)}
                        prd={prd}
                    />
                ))}
            <div className="d-flex justify-content-end mt-6">
                <Button btnStyle="primary" onClick={onNextClick} disabled={!selectedRate}>
                    <T>subscription.purchase.label.next</T>
                </Button>
            </div>
        </CardSection>
    )
}

export default connect(null, { setSearchMode })(ProductSelection)
